import { Controller } from 'react-hook-form'
import { ButtonGroupInput } from '../../inputs'
import filtersByDistance from '../../../mock_data/distanceOptions.json'
import { useI18n } from '@ggs/i18n'

/**
 * @typedef {import('react-hook-form').FieldErrors} FieldErrors
 * @typedef {import('react-hook-form').FieldValues} FieldValues
 * @typedef {import('react-hook-form').Control<FieldValues>} FormControl
 */

/**
 * @typedef {Object} DistanceFieldProps
 * @property {string} defaultValue
 * @property {FieldErrors} errors
 * @property {FormControl} control
 */

/**
 * Provides distance field form element.
 * @param {DistanceFieldProps} props
 * @return {JSX.Element}
 */
const DistanceField = ({ control, errors, defaultValue }) => {
  const { t } = useI18n()
  const errorMessage = errors.distanceFilter?.message
  const hasError = Boolean(errors.distanceFilter)
  return (
    <Controller
      control={control}
      name="searchDistance"
      defaultValue={defaultValue}
      render={({ field }) => (
        <ButtonGroupInput
          id="form-quick-search-filter-distance"
          label={t('Choose distance range')}
          error={hasError}
          // @ts-ignore
          errorHelperText={errorMessage}
          buttonOptions={filtersByDistance}
          buttonGroupFields={field}
        />
      )}
    />
  )
}

export default DistanceField
